import { createAction } from "@reduxjs/toolkit";
import _ from "lodash";
import axios from "axios";
import { call, put, takeEvery } from "redux-saga/effects";
import { FetchDraftCoursesErrorResponse, FetchDraftCoursesRequest, FetchDraftCoursesResponse, FetchPublishedCoursesErrorResponse, FetchPublishedCoursesRequest, FetchPublishedCoursesResponse } from "src/types/coaching/courses";
import { FETCH_DRAFT_COURSES_FOR_STUDIO_REQUEST, FETCH_PUBLISHED_COURSES_FOR_STUDIO_REQUEST, FETCHING_DRAFT_COURSES_FOR_STUDIO_FAILED, FETCHING_DRAFT_COURSES_FOR_STUDIO_SUCCEEDED, FETCHING_PUBLISHED_COURSES_FOR_STUDIO_FAILED, FETCHING_PUBLISHED_COURSES_FOR_STUDIO_SUCCEEDED } from "../actionTypes";
import buildUrl from "build-url-ts";

// eslint-disable-next-line no-undef
const apiUrl = `${process.env.REACT_APP_COACHING_API_URL}`;

// fetch draft courses
export const fetchDraftCourses = createAction<FetchDraftCoursesRequest>(FETCH_DRAFT_COURSES_FOR_STUDIO_REQUEST);
const fetchingDraftCoursesSucceeded = createAction<FetchDraftCoursesResponse>(FETCHING_DRAFT_COURSES_FOR_STUDIO_SUCCEEDED);
const fetchingDraftCoursesFailed = createAction<FetchDraftCoursesErrorResponse>(FETCHING_DRAFT_COURSES_FOR_STUDIO_FAILED);

const fetchDraftCoursesSaga = function* (
  action: ReturnType<typeof fetchDraftCourses>,
): any {
  const request = action.payload as FetchDraftCoursesRequest;

  const url = buildUrl(`${apiUrl}/api/1.0/courses/drafts`, {
    queryParams: {
      page: request.page,
      limit: request.limit,
      courseTypes: request.courseTypes
    }
  });

  const fetchCoursesApi = () => {
    return axios({
      method: "GET",
      url: url
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCoursesApi);
    yield put(
      fetchingDraftCoursesSucceeded({
        response: response,
      }),
    );
  } catch (error) {
    yield put(fetchingDraftCoursesFailed({ error: error }));
  }
};

// fetch draft courses
export const fetchPublishedCourses = createAction<FetchPublishedCoursesRequest>(FETCH_PUBLISHED_COURSES_FOR_STUDIO_REQUEST);
const fetchingPublishedCoursesSucceeded =  createAction<FetchPublishedCoursesResponse>(FETCHING_PUBLISHED_COURSES_FOR_STUDIO_SUCCEEDED);
const fetchingPublishedCoursesFailed = createAction<FetchPublishedCoursesErrorResponse>(FETCHING_PUBLISHED_COURSES_FOR_STUDIO_FAILED);

const fetchPublishedCoursesSaga = function* (
  action: ReturnType<typeof fetchPublishedCourses>,
): any {
  const request = action.payload as FetchPublishedCoursesRequest;

  const url = buildUrl(`${apiUrl}/api/1.0/courses/published`, {
    queryParams: {
      page: request.page,
      limit: request.limit,
      courseTypes: request.courseTypes
    }
  });

  const fetchCoursesApi = () => {
    return axios({
      method: "GET",
      url: url
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCoursesApi);
    yield put(
      fetchingPublishedCoursesSucceeded({
        response: response,
      }),
    );
  } catch (error) {
    yield put(fetchingPublishedCoursesFailed({ error: error }));
  }
};

export default function* studioSaga() {
  yield takeEvery(FETCH_DRAFT_COURSES_FOR_STUDIO_REQUEST, fetchDraftCoursesSaga);
  yield takeEvery(FETCH_PUBLISHED_COURSES_FOR_STUDIO_REQUEST, fetchPublishedCoursesSaga);
}